// src/context/SocketContext.jsx
import React, { createContext, useContext } from 'react';
import { useSocket } from '../hooks/useSocket';
import { useAuth } from '../hooks/useAuth';

// Create a context for socket functionality
export const SocketContext = createContext(null);

// Provider component that wraps the application and makes socket available to any child component that calls useSocketContext()
export const SocketProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  
  // Use the existing useSocket hook
  const socket = useSocket(isAuthenticated);
  
  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
};

// Custom hook that allows easy consumption of the socket context
export const useSocketContext = () => {
  const context = useContext(SocketContext);
  
  if (context === null) {
    throw new Error('useSocketContext must be used within a SocketProvider');
  }
  
  return context;
};